import React, { Fragment } from 'react';
import { translate } from '../../../Services/translation';
import ProductPrice from '../ProductPrice';
import ProductStockInformationContainer from '../ProductStockInformationContainer';
import ProductTags from '../ProductTags';

const ProductCard = ({ productItem, index }) => {
  const product = JSON.parse(productItem.product);
  return (
    <div
      className="product-detail__product-box"
      key={`product-slider-banner-${index}`}
    >
      <Fragment>
        <figure className="product__figure">
          {productItem.image && productItem.imageUrl ? (
            <a href={product.url}>
              <div
                className="product__image-link"
                dangerouslySetInnerHTML={{ __html: productItem.image }}
              ></div>
            </a>
          ) : (
            translate('product.noproductimage')
          )}
          <ProductTags tags={product.tags} />
        </figure>
      </Fragment>
      <article className="product__info">
        <div className="product__name-wrapper">
          <a href={product.url}>
            <h3 className="product__name">{product.name}</h3>
          </a>
        </div>
        <p className="product__name--second">{product.productItemName2}</p>
        {product.price && (
          <div className="product__price-wrap">
            <ProductPrice
              price={product.price}
              variantCount={product.variantCount}
            />
          </div>
        )}
        <div className="product__stockvariant">
          {product.temporarilyDisabledTextShort ? (
              <div className="temporarily-disabled">
                <span className="temporarily-disabled__icon"></span><span>{product.temporarilyDisabledTextShort}</span>
              </div>
          ) : (
              <ProductStockInformationContainer
                  stockInformation={product.stockInformation}
                  displayShortText={true}
              />
          )}
        </div>
        <div className="product__stockvariant">
          {product.variantCount > 1 && (
            <div className="product__variants-container">
              <div itemProp="settings" className="product__settings">
                <svg>
                  <use href="/ui/images/sprites/a-mobler.svg#wheel" />
                </svg>
              </div>
              <div itemProp="description" className="product__description">
                {product.variantText} {translate('productlist.variants')}
              </div>
            </div>
          )}
        </div>
      </article>
    </div>
  );
};

export default ProductCard;
